import contactContent from '../../content/home.json';
import { ContactSection } from '@site-factory/ui';

export default function ContactPage() {
  return (
    <div className="py-16">
      <ContactSection {...(contactContent.contact as any)} />
    </div>
  );
}
